import { useEffect, useState } from "react"
import CopyToClipboard from "react-copy-to-clipboard"
import styled from "styled-components"
import { ContentCopyIcon } from "../../icons"
import { Typography } from "../../typography"

const CopyPasteContent = styled(Typography).attrs({ as: "button" })`
  height: 1.75rem;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0.25rem;
  background-color: ${({ theme }) => theme.colors.white};
  border: 2px solid transparent;
  border-radius: 1.75rem;
  outline: none;
  cursor: pointer;

  position: relative;
  overflow: hidden;

  &:focus {
    background-color: ${({ theme }) => theme.colors.grey.$100};
    border-color: ${({ theme }) => theme.colors.grey.$400};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey.$100};
  }

  &:active {
    background-color: ${({ theme }) => theme.colors.grey.$200};
    border-color: transparent;
  }
`

const SuccessMessage = styled.span`
  position: absolute;
  left: 100%;
  visibility: hidden;

  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.primary.$200};
  padding: 0 0.25rem;
  white-space: nowrap;

  animation: show-success-message 200ms ease-out forwards;
  @keyframes show-success-message {
    100% {
      visibility: visible;
      transform: translateX(-100%);
    }
  }
`

type CopyPasteProps = {
  textToCopy: string
  successMessage: string
}

const CLEAR_SHOW_SUCCESS_MESSAGE_TIMEOUT = 2000

export const DeprecatedCopyPaste = ({ textToCopy, successMessage }: CopyPasteProps) => {
  const [showSuccessMessage, setShowSuccessMessage] = useState(false)

  useEffect(() => {
    if (showSuccessMessage) {
      setTimeout(() => {
        setShowSuccessMessage(false)
      }, CLEAR_SHOW_SUCCESS_MESSAGE_TIMEOUT)
    }
  }, [showSuccessMessage])

  return (
    <CopyToClipboard text={textToCopy} onCopy={() => setShowSuccessMessage(true)}>
      <CopyPasteContent>
        <ContentCopyIcon />
        {textToCopy}
        {showSuccessMessage && <SuccessMessage>{successMessage}</SuccessMessage>}
      </CopyPasteContent>
    </CopyToClipboard>
  )
}
